import { getEnv } from '@/lib/env'

/**
 * Redirige al login propio del portal. Usado por el errorLink de Apollo y
 * por RequireAuth cuando no hay sesión activa.
 */
export function redirectToLogin(): never {
  window.location.assign('/login')
  throw new Error('Redirecting to login')
}

export function redirectToIdentityLogin(): never {
  const url = getEnv('VITE_IDENTITY_LOGIN_URL_REDIRECT')
  if (!url) {
    throw new Error(
      'VITE_IDENTITY_LOGIN_URL_REDIRECT no está configurada. Revisa .env o las vars del contenedor.',
    )
  }
  window.location.assign(url)
  throw new Error('Redirecting to Identity login')
}

export function isLoginCallback(): boolean {
  return new URLSearchParams(window.location.search).get('callback') === 'login'
}

export function cleanCallbackFromUrl(): void {
  const url = new URL(window.location.href)
  url.searchParams.delete('callback')
  const search = url.searchParams.toString()
  const newUrl = `${url.pathname}${search ? `?${search}` : ''}${url.hash}`
  window.history.replaceState({}, '', newUrl)
}
